import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

const ErrorFallback = ({
  error,
  resetErrorBoundary,
}: {
  error: Error;
  resetErrorBoundary: () => void;
}) => {
  return (
    <Box
      className='flex flex-col items-center justify-center h-screen bg-gray-100'
      sx={{ p: 4 }}
    >
      <Typography variant='h4' gutterBottom className='text-red-500'>
        Something went wrong
      </Typography>
      <Typography variant='body1' gutterBottom className='text-gray-700 mb-4'>
        {error.message}
      </Typography>
      <Button
        variant='contained'
        color='primary'
        onClick={resetErrorBoundary}
        className='bg-blue-500 hover:bg-blue-600 transition-colors duration-300'
      >
        Try Again
      </Button>
    </Box>
  );
};

export default ErrorFallback;
